import { useTranslation } from 'react-i18next'

import { Ethereum } from '@/components/atoms/assets/Ethereum'

export const NetworkInfo = () => {
  const { t } = useTranslation('common')

  return (
    <div className="flex flex-row justify-between items-center mb-8 py-1 text-cool-gray-300">
      <span className="text-xs uppercase">{t('withdraw.network')}</span>
      <div className="flex flex-row">
        <Ethereum />
        <span className="ml-2 text-white font-bold">
          {t('withdraw.ethereumErc20')}
        </span>
      </div>
    </div>
  )
}
